import React = require("react");
import {HorizontalScrollbar} from "../../../components/Utils/scrollbar/HorizontalScrollbar";
import "./EquipmentImages.scss";
import {ProtectedImageDisplay} from "../../../components/ProtectedImageDisplay";

interface EquipmentImage {
    href: string;
    label?: string;
}

interface BarcaImagesProps {
    title: string;
    titleValue?: string;
    subtitle?: string;
    images: EquipmentImage[];
    noImagesAvailableText;
}

export class BarcaImageSection extends React.Component<BarcaImagesProps, any> {
    constructor(props) {
        super(props);
    }

    public render() {
        if (this.props.images == null) {
            return null;
        }

        const images = this.props.images.map(
            (image, index) => (
                <div className={"b-image"} key={index}>
                    <ProtectedImageDisplay src={image.href} alt={image.label} key={image.href}/>
                    {image.label && <p className="legend">
                        <img
                            className={"cam-image"}
                            src={"./images/cam.png"}
                        />
                        {image.label}
                    </p>}
                </div>
            ),
        );

        return (
            <div className="settings-section">
                <div className="settings-header">
                    <p className="settings-header__label">
                        {this.props.title}
                        {this.props.titleValue != null && (
                            <React.Fragment>
                                <span>: </span>
                                <span className="settings-header__title">{this.props.titleValue}</span>
                            </React.Fragment>)}
                    </p>
                    {this.props.subtitle && <p className="settings-header__sublabel">{this.props.subtitle}</p>}
                </div>
                <div className={"settings-body carousel-container"}>
                    <HorizontalScrollbar>
                        <div className="settings-content-flex">
                            {images}
                        </div>
                    </HorizontalScrollbar>
                </div>
            </div>
        );
    }
}
